import React from 'react';
import DatePicker from '../DatePicker/DatePicker';

const FormDateCalendar = (props) => {
    return <DatePicker {...props} />;
};
export default FormDateCalendar;
